import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  Panel,
  Button,
  Message,
  Grid,
  Row,
  Col,
  Icon,
  ControlLabel,
  Cascader,
  Input,
  Checkbox,
} from 'rsuite'
import WithdrawalEditTable from './WithdrawalEditTable'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, isRequired } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import { startLoading, doneLoading } from '../../utils/loading'
import {
  saveRequestMultipleReviewer,
  saveReviewerPaymentApprover,
} from '../../redux/actions/withdrawReviewPayment'
import { isEmpty } from 'lodash-es'
import notification from '../../utils/notification'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  CONFIRM_MSG,
  DEFAULT_ERR_MSG,
  PLEASE_CONFIRM_MSG,
  SAVE,
  SAVE_APPROVE_SUCCESS_MSG,
  SAVE_DRAFT_MSG,
  SAVE_DRAFT_SUCCESS_MSG,
  SAVE_SUCCESS_MSG,
} from '../../constants/msgText'
import InputForm from '../../components/forms/input/InputForm'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'

export default function WithdrawalPanel({
  schema,
  projectData,
  onCancelShowTable,
  onButtonSuccess= () => {},
  onSuccess,
  isApproveSuccess = () => {},
}) {
  const { handleSubmit, errors, control, setValue, watch, register, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [formSchema, setFormSchema] = useState()
  const [isShowConfirmSendApprove, setIsShowConfirmSendApprove] = useState(false)
  const [isShowConfirmApprove, setIsShowConfirmApprove] = useState(false)
  const [isShowConfirmNotApprove, setIsShowConfirmNotApprove] = useState(false)
  const [isShowConfirmSaveDraft, setIsShowConfirmSaveDraft] = useState(false)
  const [isAlreadyWithdraw, setIsAlreadyWithdraw] = useState(false)
  const [requestBody, setRequestBody] = useState()
  const [workPlanCodeVal, setWorkPlanCodeVal] = useState()
  const [budgetVal, setBudgetVal] = useState()

  const dispatch = useDispatch()
  // const { projectId } = useParams()
  {
    console.log('masterBudgetPlan  ===>', workPlanCodeVal?.masterBudgetPlan)
  }
  useEffect(() => {
    setFormSchema(schema)
    console.log(schema)

    if(schema?.projectBudgetPlan?.masterBudgetPlan?.value){
      setWorkPlanCodeVal(schema?.projectBudgetPlan?.masterBudgetPlan?.value)
      console.log(schema?.projectBudgetPlan?.masterBudgetPlan?.value)
    }

    if(schema?.budget?.reviewerData?.length > 0){
      var total = getTotalSummary(schema?.budget?.reviewerData)
      setBudgetVal(total)
      console.log(total)
    }
    
  }, [schema])

  useEffect(() => {
    if (formSchema?.alreadyWithdraw && !formSchema?.budget?.approveButtonText) {
      setIsAlreadyWithdraw(formSchema.alreadyWithdraw.alreadyWithdraw.value)
    }
  }, [formSchema])

  const handleCallApiSendApprove = async () => {
    startLoading()
    setIsLoading(true)
    setIsShowConfirmSendApprove(false)
    setIsError(false)
    try {
      const response = await saveRequestMultipleReviewer(requestBody)
      response.model.forms.header = formSchema.header
      if (response.success) {
        setFormSchema(response.model.forms)

        if (response.model?.responseValidate?.isSuccess) {
          onSuccess(
            requestBody.status,
            response?.model?.forms?.budget?.reviewerData[0]?.projectReviewerPaymentId || null
          )
          notification.open('success', {
            title: SAVE_SUCCESS_MSG,
            duration: 10000,
          })
        } else {
          setIsError(response.model?.responseValidate?.message || DEFAULT_ERR_MSG)
        }
      }
    } catch (e) {
      setIsError(
        e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || DEFAULT_ERR_MSG
      )
    }
    setIsShowConfirmSendApprove(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleCallApiApprove = async () => {
    startLoading()
    setIsLoading(true)
    setIsShowConfirmApprove(false)
    setIsShowConfirmNotApprove(false)
    setIsError(false)
    try {
      //const response = await approvePaymentReview(requestBody)
      const response = await saveReviewerPaymentApprover(requestBody)
      response.model.forms.header = formSchema.header
      if (response.success) {
        setFormSchema(response.model.forms)

        isApproveSuccess()

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 10000,
        })
      }
    } catch (e) {
      console.log('WithdrawalPanel : ', e)
      setIsError(
        e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || DEFAULT_ERR_MSG
      )
    }
    setIsShowConfirmApprove(false)
    setIsShowConfirmNotApprove(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleCallApiSaveDraft = async () => {
    startLoading()
    setIsLoading(true)
    setIsShowConfirmSaveDraft(false)
    setIsError(false)
    try {
      const response = await saveRequestMultipleReviewer(requestBody)
      response.model.forms.header = formSchema.header
      if (response.success) {
        setFormSchema(response.model.forms)

        if (response.model?.responseValidate?.isSuccess) {
          onSuccess(
            requestBody.status,
            response?.model?.forms?.budget?.reviewerData[0]?.projectReviewerPaymentId || null
          )

          notification.open('success', {
            title: SAVE_DRAFT_SUCCESS_MSG,
            duration: 10000,
          })
        } else {
          setIsError(response.model?.responseValidate?.message || DEFAULT_ERR_MSG)
        }
      }
    } catch (e) {
      setIsError(
        e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || DEFAULT_ERR_MSG
      )
    }
    setIsShowConfirmSaveDraft(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleOnConfirmSendApprove = (data) => {
    console.log('data send approve', data)
    setIsError(false)

    // if(isEmpty(data.masterBudgetPlan)){
    //   console.log('no masterBudgetPlan')
    //   setError('masterBudgetPlan', {message: 'กรุณาเลือกแผนงบประมาณ', type: 'required'})
    //   return
    // }

    var _reviewerData = formSchema?.budget?.reviewerData.map((item) => {
      let _data = {
        reviewerId: item.id,
        reviewerName: item.reviewerName,
        amount: data[`cost_${item.id}`],
        projectReviewerPaymentId: item.projectReviewerPaymentId,
        bankName: item.bankName,
        bankBranch: item.bankBranch,
        bankAccountNumber: item.bankAccountNumber,
        // bankName: data[`bankName_${item.id}`],
        // bankBranch: data[`bankBranch_${item.id}`],
        // bankAccountNumber: data[`bankAccountNumber_${item.id}`],
      }
      return _data
    })

    let status = '2'
    let note = ''

    if (isAlreadyWithdraw) {
      status = '10'
      note = data.alreadyWithdrawNote
    }

    //const reviewerData = _reviewerData.filter(item => !item.amount == 0)
    const reviewerData = _reviewerData.filter(
      (item) => item.reviewerId && item.bankAccountNumber && (!item.amount == 0 || status == '10')
    )
    //const reviewerData = _reviewerData.filter(item => item.reviewerId)

    if (reviewerData.length == 0) {
      setIsError('ไม่มีผู้ทรงคุณวุฒิที่สามารถขออนุมัติเบิกจ่ายได้')
      return
    }

    const request = {
      projectVersionId: projectData.projectVersionId,
      projectCode: projectData.code,
      //projectReviewerPaymentId: projectReviewerPaymentId,
      workPlanCode: data.masterBudgetPlan,
      reviewerRequests: reviewerData,
      status: status,
      note: note,
    }

    console.log('request', request)
    setRequestBody(request)
    setIsShowConfirmSendApprove(true)
  }

  const handleOnConfirmApprove = (data, approve) => {
    console.log('data approve', data)

    const projectReviewerPaymentId = formSchema?.budget?.reviewerData[0].id

    let request = {
      //projectVersionId: projectVersionId,
      projectReviewerPaymentId: projectReviewerPaymentId || null,
      requestNote: data.requestNote,
      status: approve ? 3 : 4,
    }

    console.log(request)
    setRequestBody(request)

    if (approve) {
      setIsShowConfirmApprove(true)
    } else {
      setIsShowConfirmNotApprove(true)
    }
  }

  const handleOnSaveDraft = (data) => {
    console.log('data send draft', data)
    setIsError(false)

    var _reviewerData = formSchema?.budget?.reviewerData.map((item) => {
      let _data = {
        reviewerId: item.id,
        reviewerName: item.reviewerName,
        amount: data[`cost_${item.id}`],
        bankName: item.bankName,
        bankBranch: item.bankBranch,
        bankAccountNumber: item.bankAccountNumber,
        projectReviewerPaymentId: item.projectReviewerPaymentId,
        // bankName: data[`bankName_${item.id}`],
        // bankBranch: data[`bankBranch_${item.id}`],
        // bankAccountNumber: data[`bankAccountNumber_${item.id}`],
      }
      return _data
    })

    // const reviewerData = _reviewerData.filter(item => !item.amount == 0)
    const reviewerData = _reviewerData.filter((item) => item.reviewerId && item.bankAccountNumber)
    //const reviewerData = _reviewerData.filter(item => item.reviewerId)

    // console.log('reviewerData', reviewerData)
    // if(reviewerData.length == 0){
    //   setIsError("กรุณากรอกจำนวนเงินที่ต้องการขอเบิก อย่างน้อย 1 ท่าน")
    //   return
    // }

    const request = {
      projectVersionId: projectData.projectVersionId,
      projectCode: projectData.code,
      //projectReviewerPaymentId: projectReviewerPaymentId,
      workPlanCode: data.masterBudgetPlan,
      reviewerRequests: reviewerData,
      status: '1',
    }

    console.log('request', request)
    setRequestBody(request)
    setIsShowConfirmSaveDraft(true)
  }

  const getMasterBudgetPlanLabel = (masterBudgetPlan) => {
    const planCode = masterBudgetPlan.value
    let planLabel = ''
    let workPlanLabel = ''
    let actionPlanLabel = ''
    if (planCode) {
      masterBudgetPlan?.items?.forEach((planItem) => {
        if (planItem.value == planCode.substring(0, 2)) {
          planLabel = planItem.label
          planItem?.children?.forEach((workPlanItem) => {
            if (workPlanItem.value == planCode.substring(0, 6)) {
              workPlanLabel = workPlanItem.label
              workPlanItem?.children?.forEach((actionPlanItem) => {
                if (actionPlanItem.value == planCode) {
                  actionPlanLabel = actionPlanItem.label
                }
              })
            }
          })
        }
      })
      //console.log('planCodeLabel', planCodeLabel)
      return `${planCode} ( ${planLabel} / ${workPlanLabel} / ${actionPlanLabel} )`
    } else {
      return
    }
  }

  const getTotalSummary = (_tableData) => {
    return _tableData.reduce((pre, cur) => {
      if (cur.cost && !cur.isTotal) {
        return pre + cur.cost
      }
      return pre
    }, 0)
  }

  return (
    <>
      {formSchema && (
        <Panel header={formSchema.header} collapsible bordered defaultExpanded>
          <div style={{ marginBottom: 10 }}>
            <p>
              {formSchema.budget?.budgetSummaryHeader}{' '}
              <strong>{`${
                formSchema.budget ? formSchema.budget.budgetSummary?.toLocaleString() : 0
              } บาท`}</strong>
            </p>
          </div>

          {formSchema.projectBudgetPlan?.masterBudgetPlan?.readOnly ? (
            <div style={{ marginBottom: 10 }}>
              <p>
                {formSchema.projectBudgetPlan?.masterBudgetPlan.label}{' '}
                <strong>
                  {getMasterBudgetPlanLabel(formSchema.projectBudgetPlan?.masterBudgetPlan)}
                </strong>
              </p>
            </div>
          ) : (
            <Row style={{ marginBottom: 10 }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <ControlLabel
                  className={classNames(
                    isRequired(formSchema.projectBudgetPlan?.masterBudgetPlan?.validators) &&
                      'required'
                  )}
                >
                  {formSchema.projectBudgetPlan?.masterBudgetPlan?.label}
                </ControlLabel>
                <ErrorMessage error={errors.masterBudgetPlan} />
                <Controller
                  name={'masterBudgetPlan'}
                  control={control}
                  defaultValue={formSchema.projectBudgetPlan?.masterBudgetPlan.value}
                  rules={isValidators(formSchema.projectBudgetPlan?.masterBudgetPlan.validators)}
                  render={(props) => {
                    return (
                      <Cascader
                        size="lg"
                        block
                        menuWidth={220}
                        data={formSchema.projectBudgetPlan?.masterBudgetPlan.items}
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          setValue('subBudgetPlan', null)
                          setWorkPlanCodeVal(value)
                        }}
                        placeholder={formSchema.projectBudgetPlan?.masterBudgetPlan?.label}
                      ></Cascader>
                    )
                  }}
                />
              </Col>
            </Row>
          )}

          <div style={{ marginBottom: 10 }}>
            <p>
              {formSchema.budget?.numberOfReviewerHeader}{' '}
              <strong>{`${
                formSchema.budget ? formSchema.budget.numberOfReviewer?.toLocaleString() : 0
              } ท่าน`}</strong>
            </p>
          </div>

          <div style={{ marginBottom: 10 }}>
            <WithdrawalEditTable
              data={formSchema.budget?.reviewerData}
              readOnly={formSchema.budget?.readOnly}
              register={register}
              errors={errors}
              control={control}
              onChangeTotal={(total) => setBudgetVal(total)}
            />
          </div>

          {formSchema?.requestNote &&
            formSchema?.budget?.approveButtonText &&
            formSchema?.budget?.notApproveButtonText && (
              <Row>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <ControlLabel
                    className={classNames(
                      isRequired(formSchema.requestNote.validators) && 'required'
                    )}
                  >
                    {formSchema.requestNote.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.requestNote} />
                  <Input
                    placeholder={formSchema.requestNote.hint}
                    defaultValue={formSchema.requestNote.value}
                    name={formSchema.requestNote.name}
                    componentClass="textarea"
                    inputRef={register(isValidators(formSchema.requestNote.validators))}
                  />
                </Col>
              </Row>
            )}

          {formSchema?.alreadyWithdraw && !formSchema?.budget?.approveButtonText && (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Checkbox
                  disabled={formSchema.alreadyWithdraw?.readOnly}
                  name={formSchema.alreadyWithdraw.alreadyWithdraw.name}
                  checked={isAlreadyWithdraw}
                  onChange={(value, checked) => {
                    setIsAlreadyWithdraw(checked)
                  }}
                >
                  {formSchema.alreadyWithdraw.alreadyWithdraw.label}
                </Checkbox>
              </Col>
              {isAlreadyWithdraw && (
                <Col xs={24} sm={24} md={24} lg={24}>
                  <InputForm
                    disabled={formSchema.alreadyWithdraw?.readOnly}
                    schema={formSchema.alreadyWithdraw.alreadyWithdrawNote}
                    rows={3}
                    componentClass="textarea"
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
              )}
            </Row>
          )}

          <Grid fluid>
            <Row>
              {isError && (
                <Col style={{ marginTop: 10 }} xs={24} sm={24} md={24} lg={24}>
                  <Message showIcon type="error" description={isError} />
                </Col>
              )}
              <Col
                style={{ marginTop: 20, marginBottom: 20, textAlign: 'right' }}
                xs={24}
                sm={24}
                md={24}
                lg={24}
              >
                {formSchema?.budget?.readOnly ? (
                  <Row>
                    {formSchema?.budget?.approveButtonText && (
                      <Button
                        style={{ width: 'auto', marginRight: 5 }}
                        color="rgb(45, 168, 136)"
                        appearance="primary"
                        onClick={handleSubmit((e) => handleOnConfirmApprove(e, true))}
                        disabled={isLoading}
                      >
                        {formSchema?.budget?.approveButtonText}
                      </Button>
                    )}
                    {formSchema?.budget?.notApproveButtonText && (
                      <Button
                        style={{ width: 'auto' }}
                        appearance="ghost"
                        onClick={handleSubmit((e) => handleOnConfirmApprove(e, false))}
                        disabled={isLoading}
                      >
                        {formSchema?.budget?.notApproveButtonText}
                      </Button>
                    )}
                  </Row>
                ) : (
                  formSchema?.budget?.sendApproveButtonText && (
                    <Row>
                      {/* <Button
                        style={{ width: 'auto', marginBottom: 10, marginRight: 5 }}
                        color="rgb(45, 168, 136)"
                        appearance="primary"
                        onClick={handleSubmit(handleOnSaveDraft)}
                        icon={<Icon appearance="ghost" icon="edit" />}
                        disabled={isLoading || isAlreadyWithdraw}
                      >
                        {'บันทึกร่าง'}
                      </Button> */}

                      {!isAlreadyWithdraw ? (
                        <ApproverList
                          approveType={12}
                          projectversionId={projectData.projectVersionId}
                          style={{ marginLeft: 10, marginBottom: 10 }}
                          workPlanCode={workPlanCodeVal}
                          budget={budgetVal}
                          buttontext={
                            'ตรวจสอบสายอนุมัติและ' + formSchema?.budget?.sendApproveButtonText
                          }
                          isLoading={isLoading}
                          fetchButton={(disabled) =>
                            <Button
                              style={{ width: 'auto', marginBottom: 10 }}
                              color="rgb(45, 168, 136)"
                              appearance="primary"
                              onClick={handleSubmit(handleOnConfirmSendApprove)}
                              icon={<Icon appearance="ghost" icon="edit" />}
                              disabled={disabled || isLoading}
                            >
                              {formSchema?.budget?.sendApproveButtonText}
                            </Button>
                          }
                        />
                      ) : (
                        <Button
                          style={{ width: 'auto', marginBottom: 10 }}
                          color="rgb(45, 168, 136)"
                          appearance="primary"
                          onClick={handleSubmit(handleOnConfirmSendApprove)}
                          icon={<Icon appearance="ghost" icon="edit" />}
                          disabled={isLoading}
                        >
                          {SAVE}
                        </Button>
                      )}
                    </Row>
                  )
                )}

                <Row>
                  {formSchema?.budget?.checkButton && (
                    <ApproverList
                      approveType={12}
                      projectversionId={projectData.projectVersionId}
                      style={{ marginLeft: 10 }}
                      buttontext={formSchema?.budget?.checkButton}
                      workPlanCode={workPlanCodeVal}
                      budget={budgetVal}
                      isLoading={isLoading}
                      fetchButton={(disabled) =>
                        formSchema?.budget?.fetchButton && (
                          <FetchNewApprover
                            approveType={12}
                            projectversionId={projectData.projectVersionId}
                            style={{ marginRight: 10, marginBottom: 10 }}
                            buttontext={formSchema?.budget?.fetchButton}
                            onSuccess={onButtonSuccess}
                            requestId={projectData.projectReviewerPaymentId}
                            disabled={disabled}
                          />
                        )
                      }
                    />
                  )}
                  {formSchema?.budget?.cancelButton && (
                    <CancelApprovalList
                      approveType={12}
                      projectversionId={projectData.projectVersionId}
                      style={{ marginRight: 10, marginLeft: 10 }}
                      buttontext={formSchema?.budget?.cancelButton}
                      onSuccess={onButtonSuccess}
                      requestId={projectData.projectReviewerPaymentId}
                    />
                  )}
                </Row>

                <br />
                <Row>
                  <Button
                    style={{ width: 'auto' }}
                    appearance="ghost"
                    onClick={() => {
                      onCancelShowTable()
                    }}
                    icon={<Icon appearance="chevron-circle-up" />}
                    disabled={isLoading}
                  >
                    <Icon icon="chevron-circle-up" />
                    {'  เลือกโครงการใหม่'}
                  </Button>
                </Row>
              </Col>
            </Row>
          </Grid>
        </Panel>
      )}
      <ConfirmWidget
        title={CONFIRM_MSG + (isAlreadyWithdraw ? SAVE : formSchema?.budget?.sendApproveButtonText)}
        show={isShowConfirmSendApprove}
        detail={
          PLEASE_CONFIRM_MSG +
          (isAlreadyWithdraw ? SAVE : formSchema?.budget?.sendApproveButtonText)
        }
        onCancle={() => setIsShowConfirmSendApprove(false)}
        onConfirm={handleCallApiSendApprove}
      />
      <ConfirmWidget
        title={CONFIRM_MSG + formSchema?.budget?.approveButtonText}
        show={isShowConfirmApprove}
        detail={PLEASE_CONFIRM_MSG + formSchema?.budget?.approveButtonText}
        onCancle={() => setIsShowConfirmApprove(false)}
        onConfirm={handleCallApiApprove}
      />
      <ConfirmWidget
        title={CONFIRM_MSG + formSchema?.budget?.notApproveButtonText}
        show={isShowConfirmNotApprove}
        detail={PLEASE_CONFIRM_MSG + formSchema?.budget?.notApproveButtonText}
        onCancle={() => setIsShowConfirmNotApprove(false)}
        onConfirm={handleCallApiApprove}
      />
      <ConfirmWidget
        title={CONFIRM_MSG + SAVE_DRAFT_MSG}
        show={isShowConfirmSaveDraft}
        detail={PLEASE_CONFIRM_MSG + SAVE_DRAFT_MSG}
        onCancle={() => setIsShowConfirmSaveDraft(false)}
        onConfirm={handleCallApiSaveDraft}
      />

      {isLoading && !isError && <OverlayLoader />}
    </>
  )
}
